import { atualizarStatusDaAutenticacaoRemota, findAutenticacoesRemotas, criarAutenticacaoRemota, findById } from "@/api/autenticacaoRemota";
import { AutenticacaoRemotaDTO, StatusDaAutenticacaoRemota } from "@/models";
import { AutenticacaoRemotaServiceAdapter } from "@/usecases/usuario/adapter/AutenticacaoRemotaServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";

@injectable()
export class AutenticacaoRemotaService implements AutenticacaoRemotaServiceAdapter {	
	findAutenticacoesRemotas = async (params?: any, config?: AxiosRequestConfig) => await findAutenticacoesRemotas(params, config)
	atualizarStatusDaAutenticacaoRemota = async (autenticacaoId: string, status: StatusDaAutenticacaoRemota) => 
		await atualizarStatusDaAutenticacaoRemota(autenticacaoId, status)
	criarAutenticacaoRemota = async (autenticacaoRemota: AutenticacaoRemotaDTO) => await criarAutenticacaoRemota(autenticacaoRemota)
	findById = async (autenticacaoRemotaId: string) => await findById(autenticacaoRemotaId)
}